import React from 'react';
import { motion } from 'framer-motion';
import { UserCheck, Zap, DollarSign, ShieldCheck, Clock, ThumbsUp, AlertTriangle } from 'lucide-react';
const features = [{
  icon: UserCheck,
  text: 'Atención personalizada'
}, {
  icon: Zap,
  text: 'Cotización rápida'
}, {
  icon: DollarSign,
  text: 'Compramos todas las denominaciones'
}, {
  icon: ShieldCheck,
  text: 'Operaciones seguras'
}, {
  icon: Clock,
  text: 'Respuesta en minutos'
}, {
  icon: ThumbsUp,
  text: 'Evaluación sin compromiso'
}];
export function TrustFactors() {
  return <section className="py-24 bg-white border-t border-slate-200" data-id="element-162">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-164">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-165">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0a2540] mb-8" data-id="element-166">
              ¿Por qué elegirnos?
            </h2>
            <div className="grid sm:grid-cols-2 gap-6" data-id="element-167">
              {features.map((feature, index) => <div key={index} className="flex items-start gap-4" data-id="element-168">
                  <div className="mt-1 bg-blue-50 p-2 rounded-lg text-blue-700 border border-blue-100" data-id="element-169">
                    <feature.icon className="w-5 h-5" data-id="element-170" />
                  </div>
                  <span className="text-slate-700 font-medium leading-tight pt-2" data-id="element-171">
                    {feature.text}
                  </span>
                </div>)}
            </div>
          </motion.div>

          {/* Right Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-50 border border-slate-200 rounded-3xl p-8 md:p-10 relative overflow-hidden shadow-sm" data-id="element-172">
            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-100/50 rounded-bl-full" data-id="element-173"></div>

            <div className="flex items-center gap-3 mb-6" data-id="element-174">
              <AlertTriangle className="w-6 h-6 text-blue-700" data-id="element-175" />
              <h3 className="text-xl font-bold text-[#0a2540]" data-id="element-176">
                Aclaración importante
              </h3>
            </div>

            <p className="text-slate-600 leading-relaxed text-lg" data-id="element-177">
              Compramos todos los billetes estadounidenses, incluso si presentan
              daños. La cotización final dependerá del estado de conservación de
              cada billete y será determinada luego de revisar las fotografías o
              realizar una inspección presencial.
            </p>
            <div className="mt-6 inline-block bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-semibold border border-blue-200" data-id="element-178">
              Ninguno se descarta.
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}